import colorsOptions from '../../fundamentals/colors-styles/constants'

const listItemStateVariantOptions = {
  ACTIVE: 'active',
  SELECTED: 'selected',
  INACTIVE: 'inactive',
  ERROR: 'error',
  'READ-ONLY': 'read-only',
  DEFAULT: 'default',
  HOVER: 'hover'
}

const listItemStateStyleVariantOptions = {
  [listItemStateVariantOptions.DEFAULT]: {
    backgroundColor: colorsOptions.greys.white,
    color: colorsOptions.greys['grey-100'],
    secondaryColor: colorsOptions.greys['grey-70'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-100']
  },
  [listItemStateVariantOptions.ACTIVE]: {
    backgroundColor: colorsOptions.greys.white,
    color: colorsOptions.greys['grey-100'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-100']
  },
  [listItemStateVariantOptions.SELECTED]: {
    backgroundColor: colorsOptions.greys['grey-05'],
    color: colorsOptions.greys['grey-100'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-70']
  },
  [listItemStateVariantOptions.INACTIVE]: {
    backgroundColor: colorsOptions.greys.white,
    color: colorsOptions.greys['grey-40'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-40'],
    pointerEvents: 'none'
  },
  [listItemStateVariantOptions.ERROR]: {
    backgroundColor: colorsOptions.greys.white,
    color: colorsOptions.greys['grey-100'],
    border: `2px solid ${colorsOptions.semantics.danger['error-50']}`,
    iconColor: colorsOptions.greys['grey-100']
  },
  [listItemStateVariantOptions['READ-ONLY']]: {
    backgroundColor: colorsOptions.greys.white,
    color: colorsOptions.greys['grey-70'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconColor: colorsOptions.greys['grey-70']
  },
  [listItemStateVariantOptions.HOVER]: {
    backgroundColor: colorsOptions.greys['grey-05'],
    color: colorsOptions.greys['grey-100'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-70']
  }
}

const listItemListViewVariantOptions = {
  SEPARATE: 'separate',
  TOGETHER: 'together'
}

const listItemsCheckVariantOptions = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio'
}

export {
  listItemStateVariantOptions,
  listItemStateStyleVariantOptions,
  listItemListViewVariantOptions,
  listItemsCheckVariantOptions
}
